import React from 'react'
import { useController } from 'react-hook-form'
import CaluRawInput from '@/components/styledComponents/CaluRawInput'
import { parsedDniValue } from '@/utils/functions/parsedDniValue'

import PropTypes from 'prop-types'

const CaluFormInput = ({ name, multiline = false, maxRows = 15, ...props }) => {
  const {
    field: { onChange, onBlur, value },
    fieldState: { error },
  } = useController({ name })

  const isError = Boolean(error?.message)

  return (
    <CaluRawInput
      {...props}
      error={isError}
      helperText={isError ? error?.message : ''}
      onChange={onChange}
      onBlur={onBlur}
      value={name === 'dni' ? parsedDniValue(value) : value || ''}
      multiline={multiline}
      id="filled-multiline-flexible"
      maxRows={maxRows}
    />
  )
}

export default CaluFormInput

CaluFormInput.propTypes = {
  name: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
  maxRows: PropTypes.number,
}
